{
  "version": 1,
  "asset_id": "17da931b-5a77-4833-859c-46695270847e",
  "project_id": "e3708065-dee2-4f65-a2de-1d1b02caf785",
  "url": "/__l5e/assets-v1/17da931b-5a77-4833-859c-46695270847e/47-gates-of-consciousness-cover.png",
  "r2_key": "a/v1/e3708065-dee2-4f65-a2de-1d1b02caf785/17da931b-5a77-4833-859c-46695270847e/47-gates-of-consciousness-cover.png",
  "original_filename": "47-gates-of-consciousness-cover.png",
  "size": 2978695,
  "content_type": "image/png",
  "created_at": "2026-07-16T01:56:06Z"
}
